import { render, staticRenderFns } from "./TabDelivery.vue?vue&type=template&id=42244d33&scoped=true&lang=pug"
import script from "./TabDelivery.vue?vue&type=script&lang=js"
export * from "./TabDelivery.vue?vue&type=script&lang=js"
import style0 from "./TabDelivery.vue?vue&type=style&index=0&id=42244d33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42244d33",
  null
  
)

export default component.exports